/* eslint-disable max-len */
import type { SvgIconProps } from '@mui/material/SvgIcon'
import SvgIcon from '@mui/material/SvgIcon'

const SonusLogo = (props: SvgIconProps) =>
  <SvgIcon
    {...props}
    style={{
      clipRule: 'evenodd',
      fillRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox='0 0 195 195'
  >
    <path
      d='M 95.174,110.961 V 75.218 c 0.0058,-1.983468 1.405786,-3.689302 3.35,-4.082 l 12.497,-2.5 c 0.269,-0.053 0.542,-0.08 0.817,-0.08 2.284,0 4.164,1.878 4.165,4.163 v 7.415 L 99.34,83.467 v 34.159 c 0,4.604 -4.666,8.332 -10.415,8.332 -5.748,0 -10.414,-3.728 -10.414,-8.332 0,-4.603 4.666,-8.331 10.414,-8.331 2.344,0 4.508,0.619 6.249,1.666 z'
      id='path824'
    />
    <path
      d='m 187.731,61.499 c 13.075,33.188 7.355,72.387 -18.075,100.726 C 133.8,202.183 72.248,205.513 32.289,169.656 -7.669,133.799 -10.999,72.247 24.858,32.289 59.036,-5.799 116.562,-10.607 156.482,20.084 a 33.876,33.876 0 0 0 -0.861,7.614 c 0,18.097 14.234,32.895 32.11,33.801 z M 97.257,25.973 c -39.342,0 -71.284,31.941 -71.284,71.284 0,39.342 31.942,71.283 71.284,71.283 39.343,0 71.284,-31.941 71.284,-71.283 0,-39.343 -31.941,-71.284 -71.284,-71.284 z'
      id='path826'
    />
    <path
      d='m 97.257,33.965 c 34.932,0 63.291,28.36 63.291,63.291 0,34.932 -28.36,63.291 -63.291,63.291 -34.931,0 -63.291,-28.359 -63.291,-63.29 0,-34.932 28.36,-63.292 63.29,-63.292 z m 0,19.026 c 24.431,0 44.266,19.835 44.266,44.265 0,24.431 -19.835,44.266 -44.266,44.266 -24.43,0 -44.265,-19.835 -44.265,-44.266 0,-24.43 19.835,-44.265 44.265,-44.265 z'
      id='path828'
    />
  </SvgIcon>

export default SonusLogo
